import { useEffect, useState, useContext, useRef } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import {
    MdOutlineArrowLeft,
    MdOutlineSettingsInputComponent,
} from "react-icons/md";

import Main from "./Main";
import { AppContext } from "../../Context";
import { Config } from "../../inc/Config";
import { Loader, dateToText, FetchAsync, permissions } from "../../inc/Fetch";
import { Img } from "../../components/Elements";
import Filter from "../../components/Filter";
import { Input } from "../../components/Form";
import TaskList from "./components/TaskList";
import Permission from "../Permission";

import "./css/tasks.css";

export default function Site() {
    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();
    var timer = null;

    let taskCk = true;
    const lastPath = location?.pathname?.indexOf("/lessons");
    if (lastPath == -1) {
        taskCk = false;
    }

    // if (location?.split("/")?.pop())

    const { userData, siteData } = useContext(AppContext);
    const [site, setsite] = siteData;
    const [userinfo, setuserinfo] = userData;

    const [filterOpen, setfilterOpen] = useState(false);
    const [filter, setfilter] = useState({});
    const [data, setdata] = useState({});
    const [isLoading, setisLoading] = useState(true);
    // console.log(site);

    if (!params?.page) {
        params.page = 1;
    }

    let catID = site?.cats?.filter((r) => r?.name == params?.id);
    catID = catID?.length ? catID[0] : false;

    async function loadData(page) {
        let res = await FetchAsync(`task/list`, {
            _id: catID?._id,
            filter: filter,
            lessons: taskCk,
            page: page,
        });
        setdata(res);
        setisLoading(false);
    }

    // const { data, error, isLoading, refetch } = useQuery(`lessonsList-${lastPath}`, loadData);

    function searchForm(e) {
        e.preventDefault();
        loadData();
        setfilterOpen(false);
    }

    useEffect(() => {
        setisLoading(true);
        loadData(params?.page);
    }, [params?.page, taskCk]);

    if (isLoading) {
        return <Loader />;
    }

    if (!userinfo?._id || userinfo?.userlevel < 3) {
        return <Permission />;
    } else {
        let perms = permissions(userinfo, false, catID?._id, "tasks");
        if (!perms) {
            return <Permission />;
        }
    }

    let pages = Math.ceil(data?.count / 40);

    return (
        <>
            <Filter Open={filterOpen} setOpen={setfilterOpen}>
                <form onSubmit={searchForm} className="filterFormBox">
                    <div style={{ flex: 1 }}>
                        <label>
                            <span>{t("keywords")}</span>
                            <input
                                type="search"
                                onChange={(d) =>
                                    setfilter((p) => ({
                                        ...p,
                                        text: d?.target?.value,
                                    }))
                                }
                                value={filter?.text}
                                placeholder={`${t("search")}..`}
                            />
                        </label>

                        <label>
                            <span>{t("classes")}</span>
                            <select
                                onChange={(d) =>
                                    setfilter((p) => ({
                                        ...p,
                                        classes: d?.target?.value,
                                    }))
                                }
                            >
                                <option value="">--</option>
                                {Object.entries(global.Classes)?.map((v, k) => {
                                    return (
                                        <option key={k} value={v[0]}>
                                            {t("class")} {v[1]}
                                        </option>
                                    );
                                })}
                            </select>
                        </label>

                        <label>
                            <span>{t("subject")}</span>

                            <select
                                onChange={(d) =>
                                    setfilter((p) => ({
                                        ...p,
                                        subject: d?.target?.value,
                                    }))
                                }
                            >
                                <option value="">-{t("filter_all")}-</option>
                                {catID?.subs?.map((v, k) => {
                                    return (
                                        <option value={v?._id}>
                                            {v?.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </label>

                        <label>
                            <span>{t("task_added_by")}</span>

                            <select
                                onChange={(d) =>
                                    setfilter((p) => ({
                                        ...p,
                                        type: d?.target?.value,
                                    }))
                                }
                            >
                                <option value="">-{t("filter_all")}-</option>
                                <option value="admins">
                                    {t("filter_op_1")}
                                </option>
                                <option value="user">{t("filter_op_2")}</option>
                            </select>
                        </label>
                    </div>
                    <button className="btn">{t("start_searching")}</button>
                </form>
            </Filter>

            <Main>
                <div style={{ paddingTop: 155 }} className="mainWidth">
                    <nav className="breadcrumbs">
                        <Link to={`/site/${params?.id}`}>{t("home")}</Link>
                        <MdOutlineArrowLeft />
                        <Link>
                            {taskCk ? t("tasks_title") : t("task_tasks")}
                        </Link>
                    </nav>
                </div>

                <div className="section4">
                    <div className="mainWidth">
                        <div
                            style={{ marginTop: 20 }}
                            className="mainSectionBox inside"
                        >
                            <div>
                                <h1>
                                    {taskCk
                                        ? t("tasks_title")
                                        : t("task_tasks")}
                                </h1>
                                <hr />
                            </div>
                            <div style={{ display: "flex", gap: 5 }}>
                                <Link
                                    onClick={() => setfilterOpen((r) => !r)}
                                    title={t("filter")}
                                    className="btn openFilter"
                                >
                                    <MdOutlineSettingsInputComponent />
                                </Link>
                                {userinfo?.userlevel >= 3 && (
                                    <Link
                                        to={`/${taskCk ? "lesson" : "task"}/new/${params?.id}`}
                                        className="btn addTask"
                                    >
                                        {taskCk
                                            ? t("tasks_add_new")
                                            : t("task_new")}
                                    </Link>
                                )}
                            </div>
                        </div>

                        <div className="taskListBox">
                            {data?.tasks?.map((v, k) => {
                                return (
                                    <TaskList
                                        type={taskCk}
                                        locked={true}
                                        v={v}
                                        key={k}
                                    />
                                );
                            })}
                        </div>
                        {!data?.tasks?.length ? (
                            <div
                                style={{
                                    color: "#111",
                                    textAlign: "center",
                                    paddingTop: 30,
                                }}
                            >
                                {t("error", { returnObjects: true })[1]}
                            </div>
                        ) : (
                            false
                        )}

                        {pages > 0 && (
                            <nav className="pagingBox">
                                {/* data?.count */}
                                {Array.from(Array(pages), (e, i) => {
                                    let lin = `/site/${params?.id}/${!taskCk ? "tasks" : "lessons"}/${i + 1}`;
                                    if (!i) {
                                        lin = `/site/${params?.id}/${!taskCk ? "tasks" : "lessons"}`;
                                    }

                                    return (
                                        <Link
                                            to={lin}
                                            className={`${params?.page == i + 1 ? "ck" : "null"}`}
                                            key={i}
                                        >
                                            {i + 1}
                                        </Link>
                                    );
                                })}
                            </nav>
                        )}
                    </div>
                </div>
            </Main>
        </>
    );
}
